import React from 'react'
import { Carousel } from 'react-bootstrap'


function ProductCarousel() {
  const images = [
    `https://${process.env.REACT_APP_LINODE_BUCKET}.${process.env.REACT_APP_LINODE_BUCKET_REGION}.linodeobjects.com/images/carousel/1.jpg`,
    `https://${process.env.REACT_APP_LINODE_BUCKET}.${process.env.REACT_APP_LINODE_BUCKET_REGION}.linodeobjects.com/images/carousel/2.jpg`,
    // Add more image paths as needed
  ];
  return (
      <Carousel 
          pause='hover' 
          className='bg-light' 
          fade={true} 
          interval={15000}
          indicators={false}
          >
      {images.map((image, index) => (
        <Carousel.Item key={index}>
          <img
            className='d-block w-100'
            src={image}
            alt={`Slide ${index + 1}`}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

    

// function ProductCarousel() {
//     const dispatch = useDispatch()

//     const productTopRated = useSelector(state => state.productTopRated)
//     const { error, loading, products } = productTopRated

//     useEffect(() => {
//         dispatch(listTopProducts())
//     }, [dispatch])

//     return (loading ? <Loader />
//         : error
//             ? <Message variant='danger'>{error}</Message>
//             : (
//                 <Carousel pause='hover' className='bg-dark'>
//                     {products.map(product => (
//                         <Carousel.Item key={product._id}>
//                             <Link to={`/product/${product._id}`}>
//                                 <Image src={product.image} alt={product.name} fluid />
//                                 <Carousel.Caption className='carousel.caption'>
//                                     <h4>{product.name} </h4>
//                                 </Carousel.Caption>
//                             </Link>
//                         </Carousel.Item>
//                     ))}
//                 </Carousel>
//             )

//     )
// }

export default ProductCarousel
